export function canHandleAllErrors() {
    return true;
}
